//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Api from '@/utils/api';
export default {
    data() {
        return{
            orderNum: {}
        }
    },
    created() {
        Api.getOrdersCounts()
            .then(res => {
                this.orderNum = res.data
            })
    },
    computed: {

    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/TopNav.vue